export default "__VITE_ASSET__b8c3f312__"